import { useGetCompanies } from '@services/companies'
import {
  ChargingPointDetailStatusColor,
  IChargingPoint,
} from '@services/device'
import { Drawer } from '@shared/innmaxUI'
import { Divider } from 'antd'
import cx from 'classnames'
import { pathOr } from 'ramda'
import styled from 'styled-components'

type IParkingSpaceDetailModalProps = {
  open: boolean
  onCancel: () => void
  data: IChargingPoint
}

const ParkingSpaceDetailModal = (props: IParkingSpaceDetailModalProps) => {
  const { open, onCancel, data } = props

  return (
    <DrawerStyled
      open={open}
      placement="bottom"
      onClose={onCancel}
      title={null}
      height={'60%'}
      footer={null}
      closable={false}
      bodyStyle={{
        padding: 0,
      }}
      contentWrapperStyle={{
        background: 'transparent',
      }}
      drawerStyle={{
        background: '#272727',
        paddingTop: '20px',
        borderTopLeftRadius: '20px',
        borderTopRightRadius: '20px',
      }}>
      <div className="flex items-center justify-center">
        <div className="w-128 h-64 flex-row-reverse flex">
          {data.connectors
            ?.sort((a, b) => (a.connectorId ?? 0) - (b.connectorId ?? 0))
            ?.map((connector, index) => (
              <div
                key={connector.id}
                style={{
                  backgroundColor:
                    ChargingPointDetailStatusColor[
                      connector.detailedStatus || 'Unavailable'
                    ],
                }}
                className={cx(
                  'flex-1 border border-white',
                  'flex justify-center items-center ',
                  'text-primary-yellow text-2xl font-semibold'
                )}>
                {pathOr('--', [connector.connectorId + ''], {
                  '1': 'A',
                  '2': 'B',
                })}
              </div>
            ))}
        </div>
      </div>
      <div className="p-20">
        <DetailInfos
          data={data?.connectors?.filter(c => c.connectorId === 1)?.[0]}
        />
        <Divider className="border-primary" />
        <DetailInfos
          data={data?.connectors?.filter(c => c.connectorId === 2)?.[0]}
        />
      </div>
    </DrawerStyled>
  )
}

export default ParkingSpaceDetailModal

const DetailInfoRow = (props: { label: string; value: any }) => {
  const { label, value } = props
  return (
    <div className="flex justify-between gap-2 text-white text-sm my-2">
      <span className="opacity-50">{label}</span>
      <span>{value}</span>
    </div>
  )
}

const DetailInfos = (props: { data?: IChargingPoint['connectors'][0] }) => {
  const { data } = props
  const { byId: orgSessionById } = useGetCompanies()

  return data ? (
    <div className={cx('flex flex-col gap-4 text-white flex-1 break-keep', {})}>
      <div className="flex">
        <div className="min-w-[45%] flex flex-col justify-between">
          <div>
            <div className="text-xl font-bold mb-5 text-[#FFCC2B]">
              {data.deviceId}
            </div>
            <div className="text-base opacity-50">
              {data?.detailedStatusStr}
            </div>
          </div>
          {data.lprNo && (
            <div className="bg-[rgba(65,164,255,0.1)] text-sm text-white w-95 h-65 flex flex-col justify-center items-center">
              <div>
                {orgSessionById[data.orgSessionId || -1]?.name || '未知公司'}
              </div>
              <div className="opacity-50">{data.lprNo || '--'}</div>
            </div>
          )}
        </div>
        <div className="min-w-[55%]">
          <DetailInfoRow label="狀態" value={data.detailedStatusStr} />
          <DetailInfoRow label="車輛編號" value={data.lprNo || '--'} />
          <DetailInfoRow
            label="電池飽和容量"
            value={
              (data.chargingPercentage ?? -1) >= 0
                ? `${data.chargingPercentage}%`
                : '--'
            }
          />
          <DetailInfoRow
            label="目前電壓"
            value={data.voltage ? `${data.voltage}V` : '--'}
          />
          <DetailInfoRow
            label="安培小時"
            value={data.current ? `${data.current}A` : '--'}
          />

          <DetailInfoRow label="充電開始時間" value={data.chargeStartAtStr} />
          <DetailInfoRow
            label="累積充電時間"
            value={data.chargingDurationSecStr}
          />
          <DetailInfoRow label="佔用時間" value={data.occupancyMinutesStr} />
        </div>
      </div>
    </div>
  ) : null
}

const DrawerStyled = styled(Drawer)`
  .ant-drawer-content {
    background: transparent;
  }
`
